import { baseApi } from "../baseApi";

export const GaonApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // CREATE
    createGaon: builder.mutation({
      query: (data) => ({
        url: "/gaon",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }),
      invalidatesTags: ["Gaon", "Waad"],
    }),

    // CREATE BULK
    createBulkGaons: builder.mutation({
      query: (data) => ({
        url: "/gaons-bulk",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }),
      invalidatesTags: ["Gaon", "Waad"],
    }),

    // GET ALL
    getGaon: builder.query({
      query: ({
        page = 1,
        limit = 10,
        search = "",
        status = "",
        waad_id = "",
      } = {}) =>
        `/gaons?page=${page}&limit=${limit}&search=${search}&status=${status}&waad_id=${waad_id}`,
      providesTags: ["Gaon"],
    }),

    // GET SINGLE
    getSingleGaon: builder.query({
      query: (id) => `/gaon/${id}`,
      providesTags: (result, error, id) => [{ type: "Gaon", id }],
    }),

    // GET GAONS BY WAAD
    getGaonsByWaad: builder.query({
      query: (waad_id) => `/gaons-by-waad/${waad_id}`,
      providesTags: ["Gaon"],
    }),

    // UPDATE
    updateGaon: builder.mutation({
      query: (data) => ({
        url: `/gaon/${data.id}`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }),
      invalidatesTags: ["Gaon", "Waad"],
    }),

    // STATUS CHANGE
    changeStatusGaon: builder.mutation({
      query: ({ id, status }) => ({
        url: `/gaon-status/${id}`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ status }),
      }),
      invalidatesTags: ["Gaon"],
    }),

    // DELETE
    deleteGaon: builder.mutation({
      query: (data) => ({
        url: `/gaon/${data.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Gaon", "Waad"],
    }),
  }),
});

export const {
  useCreateGaonMutation,
  useCreateBulkGaonsMutation,
  useGetGaonQuery,
  useGetSingleGaonQuery,
  useGetGaonsByWaadQuery,
  useUpdateGaonMutation,
  useChangeStatusGaonMutation,
  useDeleteGaonMutation,
} = GaonApi;